var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"offer_new\"\u003E\u003Coffer-form :errors=\"errors\" :demand-data=\"demandData\" @submit=\"createOffer\"\u003E\u003C\u002Foffer-form\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;